module.exports = __webpack_public_path__ + "img/l5.75d311a0.png";